import { client } from '@/services/beef'

/**
 * Verifies and email
 */
export const verifyEmail = (data: { token: string, email: string }) => {

  return client.verifyEmail({
    body: data,
  })
    .catch((error) => {

      if (error.response) {

        if (error.response.status === 400) {
          throw new Error('EmailInValid')
        }

        if (error.response.status === 403) {
          throw new Error('TokenInvalid')
        }
      }

      throw error
    })
}
